module.exports = __webpack_public_path__ + "static/part-5-3979469bceab76379187c3fd30af92f7.svg";